import { EMilliSeconds, ESeconds } from 'modules/common/constants/const';

import { StatsTimeframe } from './types';

export const ALL_CHAINS_LIMIT = 250;

export const REFETCH_STATS_INTERVAL = 5 * ESeconds.Minute;

type Map = Record<StatsTimeframe, number>;

export const statsTimeframeToIntervalMap: Map = {
  [StatsTimeframe.Hour]: 5 * ESeconds.Minute,
  [StatsTimeframe.TwoHours]: 5 * ESeconds.Minute,
  [StatsTimeframe.Day]: ESeconds.Hour,
  [StatsTimeframe.TwoDays]: ESeconds.Hour,
  [StatsTimeframe.Week]: ESeconds.Day,
  [StatsTimeframe.Month]: ESeconds.Day,
};

// used to calculate start timestamp
export const statsTimeframeToOffsetMap: Map = {
  [StatsTimeframe.Day]: EMilliSeconds.Day,
  [StatsTimeframe.Hour]: EMilliSeconds.Hour,
  [StatsTimeframe.Month]: EMilliSeconds.Month,
  [StatsTimeframe.TwoDays]: EMilliSeconds.Day * 2,
  [StatsTimeframe.TwoHours]: EMilliSeconds.Hour * 2,
  [StatsTimeframe.Week]: EMilliSeconds.Week,
};
